import { z } from 'zod';

export type AddFieldError = {
	message: string;
	field: string;
};

export const prepareFieldError =
	(ctx: z.RefinementCtx) =>
	({ field, message }: AddFieldError) => {
		ctx.addIssue({
			code: z.ZodIssueCode.custom,
			message,
			path: [`${field}`],
		});
	};
